import { ColumnType, ITypeOptions } from '../types';

const convertLookupTypeOptions = (
  typeOptions: ITypeOptions<ColumnType.LOOKUP>
): ITypeOptions => {
  const lookupTypeOptions = typeOptions.lookupTypeOptions;
  return lookupTypeOptions
    ? ({
        ...lookupTypeOptions,
        type: typeOptions.lookupColumnType,
      } as ITypeOptions)
    : ({
        type: typeOptions.lookupColumnType ?? ColumnType.LONG_TEXT,
      } as ITypeOptions);
};

export const getTypeOptions = (typeOptions: ITypeOptions): ITypeOptions =>
  typeOptions.type === ColumnType.LOOKUP
    ? convertLookupTypeOptions(typeOptions as ITypeOptions<ColumnType.LOOKUP>)
    : typeOptions;
